import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/", hash: "" },
  { label: "瓜田广场", to: "/plaza", hash: "" },
  { label: "蹲后续", to: "/#follow", hash: "#follow" },
  { label: "关于我们", to: "/about", hash: "" },
];

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (to: string, hash: string) => {
    if (hash) return false;
    if (to === "/") return location.pathname === "/";
    return location.pathname.startsWith(to);
  };

  const handleSearch = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const value = keyword.trim();
    setMenuOpen(false);
    navigate(value ? `/plaza?q=${encodeURIComponent(value)}` : "/plaza");
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/90 backdrop-blur">
      <div className="flex w-full items-center justify-between gap-4 px-4 py-3 md:px-8">
        <Link to="/" className="flex items-center gap-2.5" aria-label="瓜田吃瓜首页">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-xl font-bold text-background-50">
            瓜
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
              瓜田吃瓜
            </span>
            <span className="mt-0.5 text-[11px] text-foreground-500">围观现场 · 蹲后续</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {navItems.map((item) => {
            const active = isActive(item.to, item.hash);
            return (
              <Link
                key={item.to}
                to={item.to}
                className={`whitespace-nowrap rounded-md px-3.5 py-2 text-sm font-medium transition-colors ${
                  active
                    ? "bg-primary-100 text-primary-800"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`}
              >
                {item.label}
              </Link>
            );
          })}
        </nav>

        <div className="flex items-center gap-2">
          <form onSubmit={handleSearch} className="hidden items-center md:flex" role="search">
            <div className="flex items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3 py-1.5 transition-colors focus-within:border-primary-400">
              <span className="flex h-5 w-5 items-center justify-center text-foreground-400">
                <i className="ri-search-line text-base" aria-hidden="true"></i>
              </span>
              <input
                type="search"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜瓜、搜人、搜事件"
                aria-label="站内搜索"
                className="w-36 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none lg:w-44"
              />
            </div>
          </form>

          <Link
            to="/#follow"
            className="hidden whitespace-nowrap rounded-full bg-accent-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600 sm:inline-flex"
          >
            订阅蹲后续
          </Link>

          <button
            type="button"
            onClick={() => setMenuOpen((prev) => !prev)}
            aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
            aria-expanded={menuOpen}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 lg:hidden"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-3-line text-xl"} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 lg:hidden">
          <form onSubmit={handleSearch} role="search" className="mb-3">
            <div className="flex items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3 py-2">
              <span className="flex h-5 w-5 items-center justify-center text-foreground-400">
                <i className="ri-search-line text-base" aria-hidden="true"></i>
              </span>
              <input
                type="search"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜瓜、搜人、搜事件"
                aria-label="站内搜索"
                className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
              />
            </div>
          </form>
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setMenuOpen(false)}
                className={`rounded-md px-3 py-2.5 text-sm font-medium ${
                  isActive(item.to, item.hash)
                    ? "bg-primary-100 text-primary-800"
                    : "text-foreground-700"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}